import { render } from "./UiImageUploader.vue?vue&type=template&id=ce56b2ee&scoped=true&lang=pug"
import script from "./UiImageUploader.vue?vue&type=script&lang=js"
export * from "./UiImageUploader.vue?vue&type=script&lang=js"

import "./UiImageUploader.vue?vue&type=style&index=0&id=ce56b2ee&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce56b2ee"]])

export default __exports__